import { StatementModel } from '@/app/shared/models';
import { RefundStatus, RefundType, BrcodeType } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';
import { CreditAdjustmentCode } from './CreditAdjustmentCode.model';

export class RefundModel extends Model {
  public OpenerUserId!: string;
  public OpenerUserName!: string;
  public UpdatedUserId?: string;
  public UpdatedUserName?: string;
  public Type!: RefundType;
  public Status!: RefundStatus;
  public Name!: string;
  public Document?: string;
  public DocumentType?: string;
  public BranchNumber?: string;
  public BranchDigit?: string;
  public AccountNumber?: string;
  public AccountDigit?: string;
  public AccountType?: string;
  public FinancialInstitutionCode?: string;
  public Email?: string;
  public RandomKey?: string;
  public Phone?: string;
  public Reason?: string;
  public Created!: Date;
  public Updated?: Date;
  public Value!: number;
  public BrcodeType?: BrcodeType;
  public InstallmentId?: string;
  public FileConfirmationUri?: string;
  public RefundGroupId?: string;
  public Statements!: StatementModel[];
  public TenantId?: string;
  public CreditAdjustmentCode!: CreditAdjustmentCode;
  public ExternalRefundCovenantId?: number;
}
